import '@vfde-brix/button/dist/styles.css';
import { createButtonComponent } from '@vfde-brix/button';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-button', createButtonComponent, NO_PATTERN_BUSINESS_LOGIC);
